import React from "react";

const Suporte = () => {
  return (
    <>
      {/* CSS LOCAL – Arquivo ÚNICO */}
      <style>{`

        .suporte-wrapper {
          padding-top: 96px; /* COMPENSA HEADER FIXO */
          padding-bottom: 64px;
          background: #ffffff;
        }

        .suporte-container {
          max-width: 960px;
          margin: 0 auto;
          padding: 0 24px;
          color: #1f2937;
          line-height: 1.6;
        }

        .suporte-header h1 {
          font-size: clamp(1.9rem, 3vw, 2.4rem);
          line-height: 1.25;
          margin-bottom: 16px;
        }

        .suporte-header p {
          margin-bottom: 12px;
          color: #4b5563;
        }

        h2 {
          margin-top: 48px;
          margin-bottom: 16px;
          font-size: 1.75rem;
        }

        h3 {
          margin-top: 32px;
          margin-bottom: 12px;
          font-size: 1.35rem;
        }

        h4 {
          margin-top: 20px;
          margin-bottom: 8px;
          font-size: 1.1rem;
        }

        ul {
          padding-left: 20px;
        }

        li {
          margin-bottom: 6px;
        }

        .suporte-canais {
          margin-top: 24px;
        }

        .suporte-card {
          margin-top: 16px;
          padding: 20px;
          border: 1px solid #e5e7eb;
          border-radius: 8px;
          background: #fafafa;
        }

        .suporte-card p {
          margin-bottom: 8px;
        }

        .destaque {
          background: #f5f7fb;
          border: 1px solid #e3e7ef;
          border-radius: 10px;
          padding: 28px;
          margin-top: 40px;
        }

        .suporte-botao {
          display: inline-block;
          margin-top: 16px;
          padding: 12px 22px;
          background: #2f5bea;
          color: #ffffff;
          border-radius: 6px;
          text-decoration: none;
          font-weight: 600;
        }

        .suporte-botao:hover {
          background: #2448c5;
        }

        .suporte-footer {
          margin-top: 48px;
          color: #4b5563;
        }
      `}</style>

      {/* CONTEÚDO */}
      <main className="suporte-wrapper">
        <div className="suporte-container">
          <section className="suporte-header">
            <h1>Comunicado de Desativação do Serviço Nuvem Fiscal</h1>

            <p>Prezados(as),</p>

            <p>Conforme comunicado enviado no dia <strong>22/04/26</strong>, enfatizamos que o serviço <strong>Nuvem Fiscal</strong> será desativado no final desse mês, dia <strong>31/07/26</strong>.</p>

            <p>Recomendamos que, dentro desse prazo, sejam adotadas as providências necessárias para <strong>migração ou contratação de solução alternativa</strong>, a fim de evitar quaisquer impactos operacionais, especialmente na emissão de documentos fiscais.</p>

            <p>Nossos <a href="#canais">canais de suporte</a> permanecem à disposição para apoiá-los durante todo o processo de transição.</p>

            <p>Atenciosamente,</p>
            <p><strong>Equipe Nuvem Fiscal</strong></p>
          </section>

          <section>
            <h2>
              Canais de Atendimento
            </h2>

            <div className="suporte-canais">
              <h3>
                Comunidade ACBr
              </h3>

              <p>
                O suporte será realizado pelos canais da comunidade ACBr.
              </p>

              <div className="suporte-card">
                <h4>
                  Discord ACBr
                </h4>
                <ul>
                  <li>Acesse o servidor oficial do <a href="https://discord.gg/ACBr" target="_blank" rel="noopener noreferrer">Discord ACBr</a></li>
                  <li>Entre com sua conta e aceite as regras da comunidade</li>
                  <li>Procure o canal relacionado ao seu assunto</li>
                  <li>
                    Descreva sua dúvida com o máximo de contexto técnico possível
                  </li>
                </ul>
              </div>

              <div className="suporte-card">
                <h4>
                  Fórum ACBr
                </h4>
                <ul>
                  <li>Acesse o <a href="https://www.projetoacbr.com.br/forum/forum/103-comunidade-nuvem-fiscal/" target="_blank" rel="noopener noreferrer">Fórum ACBr</a></li>
                  <li>Faça login ou realize seu cadastro</li>
                  <li>
                    Utilize a busca para verificar se sua dúvida já foi respondida
                  </li>
                  <li>
                    Caso não encontre a solução, clique em{" "}
                    <strong>Criar Novo Tópico</strong>
                  </li>
                  <li>
                    Descreva sua dúvida com detalhes técnicos, incluindo mensagens
                    de erro, logs e prints quando aplicável
                  </li>
                </ul>
              </div>
            </div>

          </section>
        </div>
      </main>
    </>
  );
};

export default Suporte;
